import { supabase } from '@/lib/supabase';

// ─────────────────────────────────────────────────────────────
// Paiement d'un panier avec le solde du portefeuille Zifek.
//
// Le débit, le contrôle du montant et le crédit des marchands sont exécutés
// par la fonction serveur `zifek-wallet-pay`. Le navigateur n'envoie QUE les
// identifiants des commandes : il ne peut donc pas manipuler le montant.
// ─────────────────────────────────────────────────────────────

export interface WalletPayResult {
  ok: boolean;
  error?: string;
  total?: number;
  currency?: string;
  newBalance?: number;
  orderIds?: number[];
  reference?: string;
  reason?: string;
}

async function functionErrorMessage(error: unknown, fallback: string): Promise<string> {
  const ctx = (error as { context?: { json?: () => Promise<{ error?: string }> } })?.context;
  if (ctx && typeof ctx.json === 'function') {
    try {
      const body = await ctx.json();
      if (body?.error) return body.error;
    } catch {
      /* message par défaut */
    }
  }
  const message = (error as { message?: string })?.message;
  return message || fallback;
}

export async function payOrdersWithWallet(params: {
  userId: number;
  orderIds: number[];
}): Promise<WalletPayResult> {
  if (!params.userId || params.orderIds.length === 0) {
    return { ok: false, error: 'Aucune commande à payer.' };
  }

  const { data, error } = await supabase.functions.invoke('zifek-wallet-pay', {
    body: { userId: params.userId, orderIds: params.orderIds },
  });

  if (error) {
    return { ok: false, error: await functionErrorMessage(error, 'Le paiement par solde a échoué.') };
  }

  const res = (data || {}) as WalletPayResult & { error?: string };
  if (res.error) return { ok: false, error: res.error, reason: res.reason };
  return { ...res, ok: res.ok !== false };
}